// extracted by mini-css-extract-plugin
export default {"GitHubAvatar":"User-module__GitHubAvatar--pELUL","Link":"User-module__Link--xpxGG"};